<template>
  <b-modal :visible="visible" centered hide-header hide-footer ok-disabled cancel-disabled>
    <div class="text-center modal-container" :class="{ invert: invert }">
      <div class="content">
        <calling-staff-image class="image" />
        <div class="text">{{ $t('selfcheck.staffComingPleaseWait') }}</div>
      </div>
    </div>
    <div class="modal-footer">
      <slot>
        <so-button class="cancel-button" :disabled="disabled" rounded @click="$emit('cancel')">
          {{ $t('common.cancel') }}
        </so-button>
      </slot>
    </div>
  </b-modal>
</template>

<script>
import SoButton from '@/components/common/SoButton.vue'
import CallingStaffImage from '@/components/images/CallingStaffImage'

export default {
  components: {
    CallingStaffImage,
    SoButton,
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    invert: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .modal {
    top: 0px;
  }
  .modal-dialog {
    margin: 0 !important;
    height: 100%;
    max-width: 100%;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
    background: none;
  }
  .modal-body {
    height: 100%;
    padding: 0 !important;
  }
  .image {
    width: 84px;
    fill: #808080;
  }
  .invert .image {
    fill: #fff;
  }
}
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
  padding-bottom: 70px;

  &.invert {
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}
.text {
  padding-top: 30px;
  font-size: 20px;
  white-space: pre-wrap;
}
.modal-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  justify-content: center;
  width: 100%;
  border-top: none;
}
.cancel-button {
  max-width: 240px;
}
</style>
